import type { Feature, FeatureCollection, LineString } from 'geojson';

import { METRICS, type ReviewMetric } from './metricRamp';
import type { RideTrackPoint } from './rides';

/**
 * Turns a ride track into per-segment LineString features carrying the active metric's value
 * as `v`, for data-driven colouring (`line-color` interpolate on `v`) — the map "gradient
 * encodes data" review visual. line-gradient can't read per-vertex data, so segment features
 * are how we colour by metric. See CLAUDE.md → Ride Review &amp; Display.
 */
export function trackToSegments(track: RideTrackPoint[], metric: ReviewMetric): FeatureCollection<LineString> {
  const value = METRICS[metric].value;
  const features: Feature<LineString>[] = [];
  for (let i = 1; i < track.length; i++) {
    const a = track[i - 1];
    const b = track[i];
    const ends = [value(a), value(b)].filter((x): x is number => x != null);
    const v = ends.length ? ends.reduce((s, x) => s + x, 0) / ends.length : 0;
    features.push({
      type: 'Feature',
      geometry: { type: 'LineString', coordinates: [[a.lon, a.lat], [b.lon, b.lat]] },
      properties: { v },
    });
  }
  return { type: 'FeatureCollection', features };
}
